var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigniture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 420,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 131.500,158.625 C 132.611,161.898 131.500,161.625 131.500,164.625",
    strokeWidth: 5.369,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 131.500,164.625 C 125.440,174.874 127.111,175.398 120.500,185.625",
    strokeWidth: 2.742,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 120.500,185.625 C 116.948,193.463 116.940,193.374 114.500,201.625",
    strokeWidth: 2.786,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 114.500,201.625 C 112.462,208.568 112.448,208.463 111.500,215.625",
    strokeWidth: 2.968,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 111.500,215.625 C 110.006,220.637 110.962,219.568 111.500,223.625",
    strokeWidth: 3.475,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 111.500,223.625 C 114.050,226.293 112.506,225.637 116.500,225.625",
    strokeWidth: 4.476,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 116.500,225.625 C 125.508,222.469 125.050,223.293 133.500,217.625",
    strokeWidth: 3.112,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 133.500,217.625 C 141.288,211.310 142.008,212.469 149.500,205.625",
    strokeWidth: 3.121,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 149.500,205.625 C 154.242,201.925 154.288,202.310 159.500,199.625",
    strokeWidth: 3.269,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 159.500,199.625 C 164.105,197.230 162.242,198.425 165.500,198.625",
    strokeWidth: 4.204,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 165.500,198.625 C 165.500,202.125 167.105,200.230 165.500,205.625",
    strokeWidth: 4.309,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 165.500,205.625 C 166.889,211.839 165.500,211.625 165.500,217.625",
    strokeWidth: 3.406,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 165.500,217.625 C 159.684,236.687 160.889,236.839 153.500,255.625",
    strokeWidth: 2.112,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 153.500,255.625 C 151.915,261.312 151.684,261.187 149.500,266.625",
    strokeWidth: 2.878,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 149.500,266.625 C 146.809,272.331 146.915,272.312 143.500,277.625",
    strokeWidth: 3.373,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 148.500,142.625 C 153.082,146.499 152.000,147.125 155.500,151.625",
    strokeWidth: 5.213,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 155.500,151.625 C 164.626,173.574 165.582,172.999 173.500,195.625",
    strokeWidth: 2.218,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 173.500,195.625 C 181.168,214.562 181.126,214.574 188.500,233.625",
    strokeWidth: 1.732,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 188.500,233.625 C 191.266,240.551 191.168,240.562 193.500,247.625",
    strokeWidth: 2.46,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 193.500,247.625 C 193.947,253.731 194.266,250.051 194.500,252.625",
    strokeWidth: 3.496,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 194.500,252.625 C 195.669,246.034 195.947,249.731 197.500,239.625",
    strokeWidth: 4.343,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 197.500,239.625 C 200.850,228.575 200.669,228.534 204.500,217.625",
    strokeWidth: 2.758,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 204.500,217.625 C 206.750,208.750 207.350,209.075 210.500,200.625",
    strokeWidth: 2.738,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 210.500,200.625 C 213.553,191.172 212.750,195.750 216.500,191.625",
    strokeWidth: 3.193,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 216.500,191.625 C 220.369,196.916 220.053,192.172 223.500,202.625",
    strokeWidth: 4.233,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 223.500,202.625 C 228.500,212.625 228.869,212.416 233.500,222.625",
    strokeWidth: 3.213,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 254.500,163.625 C 252.027,162.855 252.000,163.125 249.500,162.625",
    strokeWidth: 5.546,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 249.500,162.625 C 246.289,161.864 246.527,162.355 243.500,162.625",
    strokeWidth: 5.392,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 243.500,162.625 C 240.520,163.605 240.789,163.364 238.500,165.625",
    strokeWidth: 5.259,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.500,165.625 C 235.257,168.817 235.520,168.605 233.500,172.625",
    strokeWidth: 5.017,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 233.500,172.625 C 232.732,175.603 232.257,175.317 232.500,178.625",
    strokeWidth: 5.015,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 232.500,178.625 C 231.455,182.491 232.232,182.103 232.500,185.625",
    strokeWidth: 4.958,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 232.500,185.625 C 234.791,187.939 233.455,188.491 236.500,190.625",
    strokeWidth: 4.26,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 236.500,190.625 C 237.360,194.218 238.291,193.439 239.500,196.625",
    strokeWidth: 4.557,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 239.500,196.625 C 241.808,199.136 241.360,198.718 244.500,199.625",
    strokeWidth: 5.032,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 244.500,199.625 C 248.539,200.341 247.308,200.136 250.500,198.625",
    strokeWidth: 5.285,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 250.500,198.625 C 251.199,195.487 252.539,196.841 252.500,192.625",
    strokeWidth: 4.877,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 252.500,192.625 C 254.521,190.317 253.699,189.987 255.500,187.625",
    strokeWidth: 4.374,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 255.500,187.625 C 256.248,184.646 256.521,184.817 256.500,181.625",
    strokeWidth: 4.81,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 256.500,181.625 C 256.500,178.625 256.748,178.646 256.500,175.625",
    strokeWidth: 5.047,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 256.500,175.625 C 255.675,166.398 256.500,172.125 256.500,168.625",
    strokeWidth: 5.074,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 256.500,168.625 C 260.036,186.294 260.675,179.898 266.500,202.625",
    strokeWidth: 5.098,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 266.500,202.625 C 271.175,209.520 269.536,210.294 275.500,216.625",
    strokeWidth: 3.277,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 183.500,161.625 C 198.795,156.781 198.500,156.125 213.500,150.625",
    strokeWidth: 4.783,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 213.500,150.625 C 219.901,146.925 220.295,147.781 226.500,143.625",
    strokeWidth: 3.387,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 226.500,143.625 C 231.854,140.705 231.901,140.925 237.500,138.625",
    strokeWidth: 3.317,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 237.500,138.625 C 241.662,138.064 241.354,137.205 245.500,136.625",
    strokeWidth: 3.584,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 245.500,136.625 C 249.408,134.415 249.662,135.064 253.500,132.625",
    strokeWidth: 4.151,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 253.500,132.625 C 257.500,131.125 257.408,130.915 261.500,129.625",
    strokeWidth: 3.857,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 261.500,129.625 C 265.513,128.158 265.500,128.125 269.500,126.625",
    strokeWidth: 3.722,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 269.500,126.625 C 273.362,123.162 272.013,125.658 274.500,124.625",
    strokeWidth: 4.091,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 274.500,124.625 C 277.316,130.242 276.862,127.662 276.500,135.625",
    strokeWidth: 4.952,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 276.500,135.625 C 273.215,146.698 274.816,146.742 269.500,157.625",
    strokeWidth: 2.743,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 269.500,157.625 C 264.434,171.602 264.715,171.698 259.500,185.625",
    strokeWidth: 2.15,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 259.500,185.625 C 254.584,198.498 254.934,198.602 250.500,211.625",
    strokeWidth: 2.149,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 250.500,211.625 C 248.526,221.296 247.584,220.998 245.500,230.625",
    strokeWidth: 2.452,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 245.500,230.625 C 242.213,239.714 242.526,239.796 238.500,248.625",
    strokeWidth: 2.576,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.500,248.625 C 234.308,257.545 234.713,257.714 230.500,266.625",
    strokeWidth: 2.597,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 230.500,266.625 C 227.700,273.025 227.808,273.045 225.500,279.625",
    strokeWidth: 2.871,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 225.500,279.625 C 223.352,286.589 223.200,286.525 221.500,293.625",
    strokeWidth: 2.98,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 221.500,293.625 C 221.230,296.193 220.852,296.089 220.500,298.625",
    strokeWidth: 3.777,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 220.500,298.625 C 217.554,302.443 219.730,301.193 218.500,303.625",
    strokeWidth: 4.602,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 218.500,303.625 C 221.802,304.889 219.554,304.943 224.500,303.625",
    strokeWidth: 5.117,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 224.500,303.625 C 260.701,284.489 261.302,286.389 297.500,266.625",
    strokeWidth: 1.497,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 297.500,266.625 C 312.562,260.264 312.201,259.489 327.500,253.625",
    strokeWidth: 1.772,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 327.500,253.625 C 334.955,250.020 335.062,250.264 342.500,246.625",
    strokeWidth: 2.367,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 342.500,246.625 C 345.365,246.178 344.955,245.520 347.500,244.625",
    strokeWidth: 3.441,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 284.500,236.625 C 282.182,238.898 283.000,239.125 281.500,241.625",
    strokeWidth: 5.564,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 281.500,241.625 C 280.782,245.272 280.682,244.898 281.500,248.625",
    strokeWidth: 4.983,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 281.500,248.625 C 282.492,252.469 282.282,252.272 284.500,255.625",
    strokeWidth: 4.902,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 284.500,255.625 C 286.610,257.525 285.992,257.969 288.500,259.625",
    strokeWidth: 4.404,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 288.500,259.625 C 290.390,263.928 291.110,262.525 293.500,265.625",
    strokeWidth: 4.504,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 293.500,265.625 C 297.815,267.310 295.890,266.928 299.500,265.625",
    strokeWidth: 5.087,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 299.500,265.625 C 300.260,261.552 301.815,263.310 301.500,257.625",
    strokeWidth: 4.682,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 301.500,257.625 C 304.178,252.244 303.260,252.052 305.500,246.625",
    strokeWidth: 3.647,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 305.500,246.625 C 305.713,243.612 306.178,243.744 305.500,240.625",
    strokeWidth: 4.373,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 305.500,240.625 C 304.200,233.524 305.213,236.612 304.500,232.625",
    strokeWidth: 4.692,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M 304.500,232.625 C 305.170,235.298 304.700,232.024 306.500,237.625",
    strokeWidth: 5.177,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M 306.500,237.625 C 309.138,242.422 309.170,242.298 312.500,246.625",
    strokeWidth: 4.151,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M 312.500,246.625 C 315.376,249.761 315.138,249.922 318.500,252.625",
    strokeWidth: 3.863,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M 318.500,252.625 C 321.883,254.770 321.376,255.261 324.500,257.625",
    strokeWidth: 3.805,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M 324.500,257.625 C 326.957,261.157 327.383,260.770 329.500,264.625",
    strokeWidth: 3.806,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M 303.500,233.625 C 300.473,233.355 300.500,233.625 297.500,233.625",
    strokeWidth: 5.57,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M 297.500,233.625 C 295.000,234.125 294.973,233.855 292.500,234.625",
    strokeWidth: 5.5,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M 285.500,235.625 C 290.500,233.625 288.000,234.625 290.500,233.625",
    strokeWidth: 5.547,
    stroke: "rgb(229, 169, 169)",
    fill: "none",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigniture);
export default __webpack_public_path__ + "static/media/signiture.df006122f6004ad80cb78ce5c26dd5ba.svg";
export { ForwardRef as ReactComponent };